<template>
  <div>
    <!-- uploadUrl -->
    <div v-if="fileList.length > 0" class="box-master" @mouseenter="enter()" @mouseleave="leave()">
      <div v-for="(item,index) in fileList" :key="index">
        <div :class="{'master': delShow}" class="box">
          <video
          v-if="item.url && videoFlag === false"
          :src="item.url"
          class="avatar"
          controls="controls">您的浏览器不支持视频播放</video>
          <i class="el-icon-zoom-in zoom-icon" @click.stop="uploadPreview(item.url)" v-if="delShow" ></i>
          <i  class="el-icon-delete del-icon" @click.stop="uploadRemove(item.name)" v-if="delShow" />
        </div>
      </div>
    </div>
    <el-upload
      ref="uploadversion"
      class="picCard-upload box"
      :http-request="uploadImg"
      accept=".mp4, .avi, .mov, .rmvb, .m4v"
      :show-file-list="false"
      :on-success="handleVideoSuccess"
      :before-upload="beforeUploadVideo"
      :on-change="uploadVideoProcess"
      action=""
      :limit="limit"
      :class="{ disabled: uploadDisabled }"
    >
      <i v-show="videoFlag === false" class="el-icon-plus video-uploader-icon" />
      <el-progress type="circle" :percentage="videoUploadPercent" v-show="videoFlag == true"/>
    </el-upload>
    <el-dialog v-model="dialogVisible">
      <video  :src="dialogImageUrl" alt="" style="width: 100%" controls="controls"/>
    </el-dialog>
    <!-- <p class="text">请保证mp4视频格式正确，且不超过50M</p> -->
  </div>
</template>
<script>
import { uploadVideoCommon } from '@/utils/utils'
export default {
  name: 'Upload',
  props: {
    fileListNew: {
      type: Array,
      default: null
    },
    type: {
      type: String,
      default: null
    },
    limit: {
      type: Number,
      default: 3
    },
    uploadType: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      dialogVisible: false,
      dialogImageUrl: '',
      videoFlag: false,
      videoUploadPercent: 0,
      delShow: false
    }
  },
  computed: {
    uploadDisabled: function () {
      let flag = false
      if (this.fileListNew.length === 1 && this.fileListNew[0].url) {
        flag = true
      }
      return flag
    },
    fileList: function () {
      return this.fileListNew
    }
  },
  created () {
  },
  methods: {
    handleClose () {
      this.dialogVisible = false
    },
    // handlePictureCardPreview (file) {
    //   this.dialogImageUrl = file.url
    //   this.dialogVisible = true
    // },
    uploadPreview (url) {
      this.dialogImageUrl = url
      this.dialogVisible = true
    },
    uploadRemove (name) {
      this.delShow = false
      console.log('fileListNew', this.fileListNew)
      // this.$emit('changeFile', [], [])
      for (const i in this.fileList) {
        if (this.fileList[i].name === name) {
          this.fileList.splice(i, 1)
          this.$refs.uploadversion.uploadFiles = []
          const fileIds = []
          this.fileList.map(item => {
            fileIds.push(item.name)
          })
          this.$emit('changeFile', this.fileList, fileIds)
          return
        }
      }
    },
    beforeUploadVideo (file) {
      console.log('fileee', file)
      const isLt50M = file.size / 1024 / 1024 < 50
      // 格式:avi、mp4、mov、rmvb、m4v，小于500M
      if (['video/mp4', 'video/avi', 'video/mov', 'video/rmvb', 'video/m4v', 'video/x-m4v'].indexOf(file.type) === -1) {
        this.$message.error('请上传正确的视频格式')
        return false
      }
      if (!isLt50M) {
        this.$message.error('上传视频大小不能超过50MB哦!')
        return false
      }
    },
    uploadVideoProcess (event, file, fileList) {
      const uploadFilesArr = this.$refs.uploadversion.uploadFiles // 上传文件列表
      console.log('uploadFilesArr', uploadFilesArr)
      console.log('file-uppp', file.type, file)
      // console.log('file-up', file)
      if (file[0].status === 'ready') {
        console.log('ready')
        this.videoFlag = true
        this.videoUploadPercent = 0
        const interval = setInterval(() => {
          if (this.videoUploadPercent >= 99) {
            clearInterval(interval)
            return
          }
          this.videoUploadPercent += 1
        }, 20)
      }
      if (file[0].status === 'success') {
        console.log('success')
        this.videoUploadPercent = 100
        this.videoFlag = false
      }
      // this.videoUploadPercent = file.percentage.toFixed(0)
    },
    handleVideoSuccess (data, file) { // 获取上传图片地址
      this.videoFlag = false
      this.videoUploadPercent = 0
      console.log('data.status', file)
      this.fileList.push({
        name: file.raw.name,
        url: `https://${data.url}`,
        uid: file.raw.uid
      })
      const fileIds = []
      this.fileList.map(item => {
        fileIds.push(item.uid)
      })
      this.$emit('changeFile', this.fileList, fileIds)
    },
    uploadImg (f) {
      uploadVideoCommon(f, f.file.uid).then(data => {
        f.onSuccess({
          // name: data.id,
          // url: data.uri
          url: `${data}`
        })
      })
    },
    enter () {
      this.delShow = true
    },
    leave () {
      this.delShow = false
    }
    // handleSuccess(data, file, fileList) {
    //   console.log('syccess')
    //   this.fileList.push({
    //     name: file.response.name,
    //     url: file.response.url,
    //     uid: file.uid
    //   })
    //   const fileIds = []
    //   this.fileList.map(item => {
    //     fileIds.push(item.name)
    //   })
    //   // this.temp.fileIds = fileIds
    //   this.$emit('changeFile', this.fileList, fileIds)
    // }
  }
}
</script>
<style lang="less">
.box-master {
  margin: 0;
  display: inline;
  vertical-align: top;
}
.master {
  position: absolute;
  left: 0;
  top: 0;
  cursor: default;
  text-align: center;
  color: #fff;
  opacity: 1;
  font-size: 20px;
  background-color: rgba(0,0,0,.5); //
  -webkit-transition: opacity .3s;
  transition: opacity .3s;
  z-index: 5;
}
.box {
  width: 100%;
  height: 100%;
  position: relative;
  width: 98px;
  height: 98px;
  margin: 0 8px 8px 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.del-icon {
  // display: flex;
  // position: absolute;
  // top: 34%;
  // right: 40%;
  color: #fff;
  font-size: 18px;
  z-index: 9;
  // margin-left: 3px;
}
.zoom-icon {
  // display: flex;
  // position: absolute;
  // top: 34%;
  // right: 40%;
  color: #fff;
  font-size: 18px;
  z-index: 9;
}
video {
  width: 100%;
  height: 100%;
  object-fit: fill;
  position: absolute;
  z-index: 1;
  left: 0;
}
.box .el-upload {
  display: inherit;
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  width: 98px;
  height: 98px;
  border-radius: 6px;
  line-height: 107px;
  box-sizing: border-box;
  position: relative;
  display: block;
}
 .box .el-progress.el-progress--circle {
  position: absolute;
  left: 10px;
  top: 10px;

}
.el-progress-circle {
  width: 80px!important;
  height: 80px!important;
}
.box.disabled {
  display: none;
}
.video-uploader-icon {
  font-size: 28px;
  color: #8c939d;
}
.el-dialog__body {
  padding: 30px 20px;
  min-height: 300px;
}
.el-icon-zoom-in {
    display: block!important;
  }
</style>
